<template>
  <Toast position="bottom-right" />
  <section class="mb-8"
    style="background-color: #000; color: #fff; min-height: 100vh; display: flex; flex-direction: column; align-items: center; justify-content: center;">
    <!-- Centered Logo -->
    <img src="https://agfenergy.it/wp-content/uploads/2023/06/marchiologo.png" alt="Company Logo" class="logo"
      style="max-width: 300px; margin-bottom: 90px;">
    <div class="row" style="display: flex; width: 100%; max-width: 1200px;">
      <div class="col" style="flex: 1; display: flex; justify-content: center; align-items: center;">
        <img src="@/assets/img/illustrazione.png" alt="" class="responsive-image"
          style="max-width: 100%; height: auto;">
      </div>
      <div class="col"
        style="flex: 1; display: flex; justify-content: center; align-items: center; text-align: left; color: #fff;">
        <div>
          <h2 class="title">OPS!</h2>
          <p class="description">
            Non sei autorizzato
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

import { computed } from 'vue'


export default {
  setup() {

    const currentYear = computed(() => new Date().getFullYear())

    return { currentYear }

  }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Host+Grotesk:ital,wght@0,300..800;1,300..800&family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');


.title {
  font-size: 10rem;
  margin: 20px 0;
  font-family: 'Host Grotesk', sans-serif;
  text-align: left;
  margin: 0;
}

.description {
  font-size: 2rem;
  font-family: 'Host Grotesk', sans-serif;
  text-align: left;
  margin: 0;
}

@media (max-width: 768px) {
  .row {
    flex-direction: column;
    align-items: center;
  }

  .col {
    flex: none;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .logo {
    margin: 0;
    max-width: 200px !important;

  }

  .responsive-image {
    max-width: 80%;
    height: auto;
  }

  .title {
    font-size: 3rem;
    margin: 10px 0;
    text-align: center;
  }

  .description {
    font-size: 1.5rem;
    margin: 0;
    text-align: center;
  }
}
</style>
